import client from './client'

export type SessionLogEvent = {
  ts: string
  type: string
  data?: Record<string, unknown>
}

export type SessionLogPayload = {
  session_id: string
  login?: string
  entered_login?: string
  user_agent?: string
  locale?: string
  time_zone?: string
  events: SessionLogEvent[]
}

export type IssueReportPayload = {
  session_id: string
  area: string
  content: string
  category: 'poprawka' | 'nowa_funkcja' | 'pytanie'
}

export const logsApi = {
  async sendSessionLog(payload: SessionLogPayload) {
    await client.post('/logs/session', payload)
  },

  async sendIssueReport(payload: IssueReportPayload) {
    await client.post('/logs/report', payload)
  }
}
